import {IHttpResponse, IHttpService, IPromise} from "angular";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {ConversionLogFilter} from "../model/ConversionLogFilter";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {ConversionReportLog} from "../model/ConversionReportLog";
import {Page} from "../../utils/models/Page";
import {ConversionLogsSelectionOptions} from "../model/ConversionLogsSelectionOptions";

export class ConversionLogService {

    static instance = [
        '$http',
        ToastNotificationServiceName,
        ConversionLogService
    ];

    constructor(private $http: IHttpService,
                private toastNotificationService: ToastNotificationService) {
    }

    public fetchConversionsLog(filter: ConversionLogFilter, pageNumber, pageSize): IPromise<Page<ConversionReportLog>> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/conversion/log'),
            data: filter,
            params: {
                pageNumber: pageNumber,
                pageSize: pageSize
            }
        }).then((resp: IHttpResponse<Page<ConversionReportLog>>) => {
            if (resp.status === 200) {
                return resp.data;
            } else {
                this.toastNotificationService.generateErrorMessage('Failed to fetch conversion logs');
                throw 'Failed to fetch conversion logs';
            }
        })
    }

    public fetchConversionsLogCsv(selectionOptions: ConversionLogsSelectionOptions): angular.IHttpPromise<unknown> {
        if (selectionOptions.allSelected) {
            return this.fetchConversionsLogCsvUsingFilter(selectionOptions.filter);
        } else {
            return this.fetchConversionsLogCsvUsingIds(selectionOptions.selectedIds);
        }
    }

    private fetchConversionsLogCsvUsingFilter(filter: ConversionLogFilter): angular.IHttpPromise<unknown> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/csv/conversion/full'),
            data: {
                filter: filter
            },
            transformResponse: [data => data],
        });
    }

    private fetchConversionsLogCsvUsingIds(selectedIds: number[]): angular.IHttpPromise<unknown> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/csv/conversion/full'),
            data: {
                selectedIds: selectedIds
            },
            transformResponse: [data => data],
        });
    }

}